<template>
  <button
    :id="id"
    class="text-white w-full"
    data-testid="locationDisplay"
    type="button"
    aria-label="Set location"
    @click="$overlay.open('locationModal', setFocus)"
  >
    <span class="flex items-center justify-between lg:p-0">
      <span class="flex items-center">
        <LocationIcon class="w-4 h-4 mr-1 fill-current" aria-hidden="true" tabindex="-1" />
        <span>{{ formattedLocation }}</span>
      </span>
      <span class="block text-gray-lighter lg:hidden"> Change </span>
    </span>
  </button>
</template>

<script lang="ts" setup>
import LocationIcon from '@/assets/location.svg?component'
const { $overlay } = useNuxtApp()
const { formattedLocation } = useLocation()
const id = useId()

function setFocus() {
  $overlay.open('mobileMenu')
  document.getElementById(id)?.focus()
}
</script>
